import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IBrandMainSectionProps {
  $bgColor?: string;
  $textColor?: string;
}

export const BrandMainSection2 = styled.div<IBrandMainSectionProps>`
  .coupon-item {
    width: calc(100% - 40px);
    margin: 0 auto 12px;
  }

  .brand-banner {
    padding: 0 20px;
    margin-bottom: 12px;
    position: relative;

    .btn-more-small {
      position: absolute;
      top: 10px;
      right: 30px;
      border-radius: 14px;
      background: rgba(0, 0, 0, 0.3);
      color: #fff;
      text-align: center;
      font-size: 11px;
      line-height: 130%;
      letter-spacing: -0.066px;
      padding: 6px 10px;
      gap: 6px;
    }
  }

  .key-visual-banner-item {
    .btn {
      pointer-events: none;
      ${mixin.flex({
        direction: 'column',
        justify: 'flex-end',
        align: 'flex-start',
      })};
      padding: 16px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );

      .title {
        font-size: 18px;
        letter-spacing: -0.6px;
        color: #fff;
      }

      .sub-title {
        margin-top: 4px;
        font-size: 14px;
        letter-spacing: -0.6px;
        color: #fff;
      }
    }

    .img {
      padding-bottom: 71.6417%;
    }
  }

  .brand-product-list {
    position: relative;
    text-align: center;
  }

  .brand-container {
    position: relative;
  }

  .coming-soon {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.6);
    z-index: 1;
  }

  .btn-more {
    background: transparent;
  }

  &.bg-type-black {
    .btn-more {
      border-color: #555;

      .text {
        color: #fff;
      }
    }

    .coming-soon {
      background: rgba(0, 0, 0, 0.6);
    }
  }

  ${({ $bgColor, $textColor }) =>
    $bgColor &&
    css`
      .brand-name {
        color: ${$textColor};
      }

      .btn-more .text {
        color: ${$textColor};
      }

      .coming-soon {
        background: ${$bgColor};
        opacity: 0.6;
      }
    `}

  @media ${({ theme }) => theme.media.smMax} {
    .coupon-item {
      width: calc(100% - ${mixin.pxToVw('40')});
      margin: 0 auto ${mixin.pxToVw('12')};
    }

    .brand-banner {
      padding: ${mixin.pxToVw('0 20')};
      margin-bottom: ${mixin.pxToVw('12')};

      .btn-more-small {
        top: ${mixin.pxToVw('10')};
        right: ${mixin.pxToVw('30')};
        border-radius: ${mixin.pxToVw('14')};
        font-size: ${mixin.pxToVw('11')};
        padding: ${mixin.pxToVw('6 10')};
        gap: ${mixin.pxToVw('6')};
      }
    }

    .key-visual-banner-item {
      .btn {
        padding: ${mixin.pxToVw('16')};

        .title {
          font-size: ${mixin.pxToVw('18')};
        }

        .sub-title {
          margin-top: ${mixin.pxToVw('4')};
          font-size: ${mixin.pxToVw('14')};
        }
      }
    }

    /* 배너 없는 케이스의 하단 자세히보기 버튼 (.brand-product-list의 text-align: center로 정렬) */
    .brand-product-list > .btn-more {
      margin-top: ${mixin.pxToVw('32')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .coupon-item {
      width: 401px;
      margin: 0;
    }

    .brand-container {
      text-align: center;

      .brand-grid {
        ${mixin.flex({
          justify: 'space-between',
          align: 'stretch',
        })};
        gap: 0 58px;

        .brand-info {
          width: 100%;
          ${mixin.flex({
            direction: 'column',
            justify: 'space-between',
            align: 'flex-start',
          })};
          padding-top: 20px;

          // event와 동일 컴포넌트 사용으로 display와 pc 해상도 기준점이 달라 스타일 재선언 함 start
          .related-brand-item {
            .btn {
              padding: 0;
            }

            .img {
              display: none;
            }

            .text {
              text-overflow: clip;
              overflow: visible;
              -webkit-line-clamp: initial;
              -webkit-box-orient: initial;
              -webkit-box-align: initial;
              word-break: normal;
              overflow-wrap: normal;
            }

            .brand-name {
              font-size: 40px;
              line-height: 120%;
              margin-bottom: 8px;
            }

            .brand-name-en {
              font-size: 16px;
              line-height: 135%;
            }
          }
          // event와 동일 컴포넌트 사용으로 display와 pc 해상도 기준점이 달라 스타일 재선언 함 end
        }
      }
    }

    .brand-banner {
      width: 780px;
      height: 400px;
      padding: 0;
      margin-bottom: 0;
      flex-shrink: 0;

      .img {
        padding-bottom: 51.28205128%;
      }

      .btn {
        padding: 32px;

        .title {
          font-size: 26px;
        }

        .sub-title {
          margin-top: 6px;
          font-size: 17px;
          font-weight: 500;
          color: #e2e2e2;
        }
      }
    }

    .brand-product-list {
      margin-top: 40px;

      .product-list {
        min-height: 359px;
      }
    }

    .product-list + .btn-more {
      margin-top: 40px;
    }

    .btn-more {
      width: 430px;
    }
  }
`;
